import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import getAxiosInstance from "../api/axiosInstance";

const getFirstInitial = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase();
};

const Staff = () => {
    const [staffList, setStaffList] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const axiosInstance = getAxiosInstance();

    useEffect(() => {
        const fetchStaffList = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await axiosInstance.get("/staff/all?noPaging=true&orderBy=first_name&&order=1");
                setStaffList(response.data);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchStaffList();
    }, []);

    const handleCardClick = (card) => {
        navigate("/checkin-out", { state: { userType: "staff", selectedUser: { id: card.staff_id, ...card } } });
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 p-8'>
            {staffList &&
                staffList.map((card, index) => (
                    <div
                        key={index}
                        className='bg-darkgrey px-2 py-6 rounded-4 cursor-pointer text-center hover:bg-orange focus:bg-orange'
                        onClick={() => handleCardClick(card)}>
                        <h2 className='text-lg font-bold'>
                            {getFirstInitial(card.first_name)}
                        </h2>
                        <p className='text-lg font-bold'>{card.last_name}</p>
                    </div>
                ))}
        </div>
    );
};

export default Staff;
